/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Doc_Cancellation_TitleInputs */

const en_checkout_doc_cancellation_title = /** @type {(inputs: Checkout_Doc_Cancellation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation Policy`)
};

/**
* | output |
* | --- |
* | "Cancellation Policy" |
*
* @param {Checkout_Doc_Cancellation_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_doc_cancellation_title = /** @type {((inputs?: Checkout_Doc_Cancellation_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Doc_Cancellation_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_doc_cancellation_title(inputs)
});